export const replaceLastPath = (url: string, path: string) => {
  const splittedUrl = url.split('/')
  return splittedUrl.slice(0, splittedUrl.length - 1).join('/') + path
}
